import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams,useNavigate } from "react-router-dom";
import { AgGridReact } from 'ag-grid-react';
import moment from 'moment';

import { useLocation } from 'react-router-dom';
import { UrlPath } from "../../../../config/routeConfig";
import { getUniverseMembersAction } from "../../../actions/universeMembers";
import { getUniverseListAction } from "../../../actions/universeListAction";

import { BreadCrumbs } from "../../../shared/breadCrumbs/BreadCrumbs";
import { TopBar } from "../../../shared/topBar/TopBar";
import { LoadingScreen } from "../../../UiComponents/LoadingComponent";
import { SBAComboBox } from "../../../UiComponents/SBADropDown";
import { SBATextBox } from "../../../UiComponents/SBATextBox";
import Form from 'react-bootstrap/Form';
import "./UniverseAdd.css";
import {getBenchmarkEntities } from '../../../actions/assetSettingsAction';
import { UniverseInsertorUpdate, getAllEntitiesGlobal} from "../../../../config/apiConfig";
import {GetAllGlobalEntities} from"../../../actions/globalSearchAction";
import { ToastContainer, toast } from 'react-toastify';
import { sbaAxios } from "../../../utils/sbaAxios";
export const UniverseDetailsAdd = () => {
    const dispatch = useDispatch();
    const history = useNavigate();
    
    const TotalavailableinvestmentApi = useRef();
    const selectedinvestmentApi = useRef();

    const Gstate = useSelector(state => state);
    const benchmarkEntities = Gstate.AllEntities.AllEntities;;
    const [availabledata, setAvailableData] = useState([]);
    const [selectedInvestment, setSelectedInvestment] = useState([]);
    const [selectedUniverseName, setSelectedUniverseName] = useState([]);
    const [selectedDescription, setSelectedDescription] = useState(null);
    const [newInvestment, setNewInvestment] = useState([]);
    const [universenametrim, setuniversenametrim] = useState();
    const [universedescr, setuniversedescr] = useState();
    const isEditable =Gstate.authorizationData.isEditable;


    
    useEffect(() => {
        
    }, [availabledata]);
    
    //Cancel button click
    const CancelButtonClick = () => {
        history(`${UrlPath.UniverseList}`);
};
 //Search Text onchange.....
    let debounceTimer;
    const changeSearchTerm = async (e) => {
        const search = e.target.value;
        const isContains = true;
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(async () => {
            if (search.length > 2) {


                try {
                    const response = await sbaAxios({
                        url: `${getAllEntitiesGlobal}${search}/${isContains}`,
                        method: 'get',
                    });
                    const data = response;
                    setAvailableData(data);
                } catch (error) {
                    console.error("Error fetching data from API:", error);
                }
            }
            else { setAvailableData([])}
        }, 100);

        search.length === 0 && setAvailableData([]);
       
    };

    //const changeSearchTerm = (e) => {
    //    debugger;
    //    const search = e.target.value;
    //    search.length > 1 && dispatch(GetAllGlobalEntities(search, "true"));
    //    setAvailableData(benchmarkEntities);
    //    search.length === 0 && setAvailableData([]);
    //}



    
//-- Left Side Grid Load Col def Start--
    const startDatevalueFormatter = (props) => {
        const date = props.data.StartDate;
    let monthName = "";
    let year = "";
    let convertedDate;
    let outPut = "";
    const monthNames = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    if (date !== null) {
        convertedDate = new Date(date);
        monthName = monthNames[convertedDate.getMonth()];
        year = convertedDate.getFullYear();
        outPut = monthName + "-" + year;
    }
    return (
        <div>{outPut
        }</div>
    );
};
const endDatevalueFormatter = (props) => {
    const date = props.data.EndDate;
    let monthName = "";
    let year = "";
    let convertedDate;
    let outPut = "";
    const monthNames = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    if (date !== null) {
        convertedDate = new Date(date);
        monthName = monthNames[convertedDate.getMonth()];
        year = convertedDate.getFullYear();
        outPut = monthName + "-" + year;
    }
    return (
        <div>{outPut
        }</div>
    );
};

const AvailableInvestmentcolDef = [
    { field: "EntityName", headerName: "Name", resizable: true },
    { field: "EntityTypeName", headerName: "Entity Type" },
    { field: "StartDate", headerName: "Start Date", cellRenderer: startDatevalueFormatter },
    { field: "EndDate", headerName: "End Date", cellRenderer: endDatevalueFormatter },
];

//-- Left Side Grid Load Col def End--


//-- Right Side Grid Load col def Start--
const getDateFormatted = (params) => {
    const isoDate = params.value;
    const formattedDate = moment(isoDate).format('MM-DD-YYYY');
    return formattedDate;
};

const columnDefs = [
    { rowDrag: true, field: "MemberName", headerName: "Investment",   flex: 1.5},
    { field: "MemberEntityTypeName", headerName: "Entity", width: 100, },
    { field: "ReturnStartDate", headerName: "Return Start Date", cellRenderer: getDateFormatted },
    { field: "ReturnEndDate", headerName: "Return End Date", cellRenderer: getDateFormatted }
];
//-- Right Side Grid Load col def End--


//-Add Investment Start-----
const addInvestment = (e) => {
 
    const newInvestment = TotalavailableinvestmentApi.current.api.getSelectedRows()[0];
    let errorMsg = [];
    if(newInvestment === undefined)
    {
        let ErrorString = "";
        errorMsg.push("Please select at least one universe member");
    errorMsg.map(item => { ErrorString = `${ErrorString}${item} \n` });
 
    toast.error(ErrorString, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
      theme: "light",
    })
  }


    newInvestment && addSelectedInvestment(newInvestment);
}
const addSelectedInvestment = (newInvestment) => {
    const newInvestmentEntityID = newInvestment.EntityId;
    if(!(selectedInvestment.filter(item=>item.MemberEntityId===newInvestmentEntityID).length>0))
    { 
        if (newInvestment.EntityTypeId !== 2 && newInvestment.EntityTypeId !== 5)
    {
  const toAdd = {
        'rowIndex': selectedInvestment.length,
        "MemberEntityId": newInvestment.EntityId,
        "MemberName": newInvestment.EntityName,
        "MemberEntityTypeId":newInvestment.EntityTypeId,
        "MemberEntityTypeName": newInvestment.EntityTypeName,
        "ReturnStartDate": newInvestment.StartDate,
        "ReturnEndDate": newInvestment.EndDate,
        "OrderId": selectedInvestment.length+1,
    };
    setSelectedInvestment((pv) => { console.log(pv); return [...pv, { ...toAdd }] });
    }
}
else
{
    toast.error("Selected Investment already Exist", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      })

}
}

//-Add Investment End-----

//-Remove Investment Start-----

const removeInvestment = () => {
    const investment = selectedinvestmentApi.current.api.getSelectedRows()[0];
    investment && removeSelectedInvestment(investment);
}

const removeSelectedInvestment = (investment) => {
    setSelectedInvestment(pv => ((pv.filter(item => item.rowIndex !== investment.rowIndex).map((item, index) => { return { ...item, rowIndex: index, SortOrder: index } }))));
}
//-Remove Investment End-----


//-- Name onchange
    const UniverseNameChange = (event) => {
        const result = SBATextBox(event.target.value)
        setuniversenametrim(result);
    setSelectedUniverseName(event.target.value);
  };

  //--Description onchange
    const DescriptionChange = (event) => {
        const result = SBATextBox(event.target.value)
        setuniversedescr(result);
    setSelectedDescription(event.target.value);
  };



//-- Add New Universe--
    const addUniverseDetails = (event) => {
    const rows=selectedInvestment?.map((item, index) => {
        return { "memberEntityId": item.MemberEntityId, "memberEntityTypeId": item.MemberEntityTypeId,  "orderId":item.OrderId }
    });
    event.preventDefault();
    let saveSuccess = true;
    let errorMsg = [];
    // Prepare the data to be sent in the POST request
    const data = {
      "UniverseId": 0,
      "UniverseName": selectedUniverseName,
      "UniverseDescription": selectedDescription,
      "UniverseMembers": rows,
      "ModifiedBy": 0
        };
        if ((universenametrim === false)|| (selectedUniverseName.length === 0)) {
            saveSuccess = false;
            errorMsg.push("Please Enter Universe Name");
        }
    if (rows.length===0) {
        saveSuccess = false;
        errorMsg.push("Please add at least one universe member");
      }
    if (saveSuccess) {
        sbaAxios({
            url: `${UniverseInsertorUpdate}`,
            method: 'post',
            data: data,
        })
        .then((response) => {
            if(response===-999)
            {
                saveSuccess = false;
                errorMsg.push("Universe Name already exsist");
                let ErrorString = "";
                errorMsg.map(item => { ErrorString = `${ErrorString}${item} \n` });
                console.log(errorMsg);
                toast.error(ErrorString, {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: false,
                  draggable: true,
                  progress: undefined,
                  theme: "light",
                })
            }
            else
            {
          toast.success('Universe Saved Successfully', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          })
          setTimeout(() => {
            history(`${UrlPath.UniverseList}`);
          }, 1000);

        
    }
})
        .catch((error) => {
          console.error(error);
        });
    }
    else {
      let ErrorString = "";
      errorMsg.map(item => { ErrorString = `${ErrorString}${item} \n` });
      console.log(errorMsg);
      toast.error(ErrorString, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      })
    }
  };

// Row Drag
  const handleRowDragEnd = (params) => {
    const rows = [];
    selectedinvestmentApi.current.api.forEachNodeAfterFilterAndSort((node) => rows.push(node.data));
    setSelectedInvestment(rows?.map((item, index) => {
        return { ...item, "rowIndex": index+1, OrderId: index+1, MemberEntityId: item.MemberEntityId, MemberEntityTypeId: item.MemberEntityTypeId,  UniverseId: parseInt(params.MemberId) }
    }));

};

const Level = [{ BreadCrumb: "Universe Add >", Routes: `${UrlPath.UniverseList}`  }]
    return (
        <div>
            <TopBar label={"Universe Add"} />
        <BreadCrumbs Levels={Level} />
        <div id="Universeadd" className='container-fluid px-3'>
                    <div className='headingGroup d-flex flex-column'>
                        <div className='lineDiv'>
                            <label id="WarningLabel"></label>
                        </div>
                        <div className='row my-1'>
                            <div className="col-md-3 pe-0">
                                <label className='label'>Universe Name <span className="mandatory">*</span></label>
                                <div>
                                <input
                                className="form-control w-100"
                                type="text"
                                onChange={UniverseNameChange}
                                required
                              />
                              </div>
                        </div>
                        <div className="col-md-3 pe-0" style={{ marginLeft: "10%" }}>
                            <label className='label'>Description</label>
                            <div>
                                <textarea id="txtStrategydesc" className="form-control" rows={2}
                                    onChange={DescriptionChange}></textarea>
                            </div>
                        </div>
                        <div className="col-md-3 pe-0">
                        <div className="col-md-9 text-end" style={{ marginLeft: "80%" }}>
                                <button className='p-sm-btn mx-1' onClick={addUniverseDetails} disabled={!isEditable}>Save</button>
                                <button className="s-sm-btn mx-1" onClick={CancelButtonClick}> Cancel</button>
                            </div>
                        </div>
                        </div>
                        
                        <div className='d-flex flex-column lineDiv my-1'>
                            <div className="row px-0 mx-0">
                                <div className="col-md-3 px-0">
                                <label className='label'>Entity</label>
                                <div>
                                    <Form.Control type="text" placeholder="Search" onKeyUp={changeSearchTerm} className='w-100 flex-grow-1 input-default' />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                        </div>
                    </div>
        <div className='gridcontent d-flex flex-row mt-3' >
                        <div className='gridDiv' >
                            <div>Available Investments</div>
                            <div className="griddata ag-theme-alpine" style={{ height: '35rem' }}>
                                <AgGridReact 
                                 columnDefs={AvailableInvestmentcolDef}
                                 rowData={availabledata}
                                 ref={TotalavailableinvestmentApi}
                                 rowSelection="single"
                                >
                                </AgGridReact>
                            </div>
                    </div>

                    
                    <div className='d-flex flex-column justify-content-center px-3'>
                        <button className='p-sm-btn my-1' onClick={addInvestment}>
                            <i class="fa-solid fa-arrow-right"></i>
                        </button>
                        <button className='p-sm-btn my-1' onClick={removeInvestment}>
                            <i class="fa-solid fa-arrow-left"></i>
                        </button>

                    </div>
                        <div className='gridDiv'>
                            <div>
                                Selected Investments
                            </div>
                         
                
                            <div className='griddata ag-theme-alpine' style={{ height: '35rem' }}>
                                <AgGridReact  
                                rowData={selectedInvestment} 
                                columnDefs={columnDefs}
                                ref={selectedinvestmentApi}
                                rowSelection="single"
                                rowDragManaged={true}
                                suppressMoveWhenRowDragging={true}
                                animateRows={true}
                               onRowDragEnd={handleRowDragEnd}
                                allowContextMenuWithControlKey={true}
                                
                                ></AgGridReact>
                            </div>
                            </div>
                            </div>
                            </div>
                            <ToastContainer></ToastContainer>
                            </div>
                            
                       
                  
       
    )

}